<template>
  <div class="bg-white">
    <div class="d-flex align-items-center bg-light p-3 mb-3 border-bottom">
      <BackButton class="ml-n3" />
      <h4 class="m-0 text-truncate" :title="item[nameKey]">{{item[nameKey]}}</h4>
      <slot name="header-buttons" :item="item" :update-item="(val) => item = val">
        <div class="ml-auto"></div>
        <DeleteButton
          :value="`/api/${type}/${id}/`"
          :name="item[nameKey]"
          @success="onDeleted($event)"
          class="mr-2"
        />
        <EditButton/>
      </slot>
    </div>

    <ErrorDisplay :value="error" class="m-3"/>

    <slot name="raw"
      v-if="$store.state.preferences.showRaw"
      :item="item"
    >
      <OptionsDisplayRaw
        class="px-3"
        :value="item"
      />
    </slot>
    <div v-else>
      <slot name="primary" :item="item">
        <OptionsDisplayApi
          class="px-3"
          :get-fields="getFields"
          :api="type"
          :value="item"
          :modify-fields="modifyFields"
          :omit-fields="omitFields ?? $store.getters['preferences/omitFields']"
        />
      </slot>
      <slot :item="item" :update-item="(val) => item = val"/>
    </div>

    <ShowFields/>
  </div>
</template>

<script>
import BackButton from '@/components/BackButton.vue'
import DeleteButton from '@/components/DeleteButton.vue'
import EditButton from './-edit-button.vue'
import OptionsDisplayApi from '@/components/OptionsDisplayApi.vue'
import OptionsDisplayRaw from '@/components/OptionsDisplayRaw.vue'
import ShowFields from '@/components/ShowFields.vue'
import { http } from '@/services/http.js'

export default {
  name: 'ManageItem',
  components: {
    BackButton,
    DeleteButton,
    EditButton,
    OptionsDisplayApi,
    OptionsDisplayRaw,
    ShowFields,
  },
  props: {
    type: String,
    id: String,
    nameKey: {
      type: String,
      default: 'name',
    },
    getItem: {
      type: Function,
      default() {
        return http.get(`api/${this.type}/${this.id}/`)
          .then(response => response.data)
      },
    },
    getFields: null,
    modifyFields: null,
    omitFields: null,
    onDeleted: {
      type: Function,
      default() {
        return this.$router.push({path: '..', append: true})
      },
    },
  },
  data() {
    return {
      error: null,
      item: {},
    }
  },
  async created() {
    await this.fetchItem()
  },
  methods: {
    async fetchItem() {
      this.item = await this.getItem()
        .catch(err => {
          this.error = err
          throw err
        })
      document.title = `${this.item[this.nameKey]} - Great American Art`
    },
  },
}
</script>
